import { DomainModel } from 'domains/models';
import { PlanId } from '../subscription/planId';
import { CallType } from './callType';

interface Props {
  teamId: number;
  uid: string;
  roomUid: string;
  startedAt: Date;
  endedAt: Date | null;
  callType: CallType;
  callableType: string;
  callableId: number;
}

export default class MeetingCall extends DomainModel {
  teamId: number;
  uid: string;
  roomUid: string;
  startedAt: Date;
  endedAt: Date | null;
  callType: CallType;
  callableType: string;
  callableId: number;

  constructor(props: Props) {
    super(props);
    this._className = 'MeetingCall';
    this.uid = props.uid;
    this.teamId = props.teamId;
    this.roomUid = props.roomUid;
    this.startedAt = props.startedAt;
    this.endedAt = props.endedAt;
    this.callType = props.callType;
    this.callableType = props.callableType;
    this.callableId = props.callableId;
  }

  static permited = ['endedAt'];

  static permit(updater: any) {
    return super.permit(updater, this.permited);
  }

  isValid() {
    super.beforeValidate();
    let p = '';

    p = 'teamId';
    if (!this.teamId) {
      this.addError(p, 'E001');
    }

    p = 'uid';
    if (!this.uid) {
      this.addError(p, 'E001');
    }

    p = 'roomUid';
    if (!this.roomUid) {
      this.addError(p, 'E001');
    }

    p = 'startedAt';
    if (!this.startedAt) {
      this.addError(p, 'E001');
    }

    p = 'endedAt';
    if (!this.endedAt) {
      this.addError(p, 'E001');
    }

    p = 'callType';
    if (!this.callType) {
      this.addError(p, 'E001');
    }

    p = 'callableType';
    if (!this.callableType) {
      this.addError(p, 'E001');
    }

    p = 'callableId';
    if (!this.callableId) {
      this.addError(p, 'E001');
    }

    return super.isValid();
  }

  static minutesBeforeWarning = 10;

  static maxDurationForPlan(planId: PlanId) {
    if (process.env['NODE_ENV'] === 'development') {
      return 999999999999;
    }
    switch (planId) {
      case PlanId.Free:
        return 40;
      case PlanId.Pro:
        return 60;
      case PlanId.Team:
      case PlanId.Enterprice:
        return 90;
      default:
        break;
    }
    return 0;
  }

  static createChannelName(teamUid: string, uid: string) {
    return `presence-${teamUid}-${uid}`;
  }

  static uidSeparator = '-';

  static createUid(
    callableType: string,
    callableUid: string,
    dateTime?: string,
  ) {
    const keys = [callableType, callableUid];
    if (dateTime) {
      keys.push(dateTime);
    }
    return keys.join(this.uidSeparator);
  }
}
